module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1506-5517da698434eb761f5330c6628b7334.png";